import { Injectable } from "@angular/core";
import { UiBlockService } from "@ankaadia/ankaadia-shared-frontend";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({ providedIn: "root" })
export class GlobalSpinnerService implements UiBlockService {
  private static readonly Name = "Main";

  constructor(private readonly spinner: NgxSpinnerService) {}

  show(): void {
    void this.spinner.show(GlobalSpinnerService.Name);
  }

  hide(): void {
    void this.spinner.hide(GlobalSpinnerService.Name);
  }
}
